import { Device } from '@ionic-native/device';
import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';

import { UniqueDeviceID } from '@ionic-native/unique-device-id';

import { AppVersion } from '@ionic-native/app-version';
import { AreaProvider } from '../providers/area/area'
import { BrComDao } from './BrComDao';
import { BrComService } from './BrComService';
import { ContatoProvider } from '../providers/contato/contato';
import { PushConfig, PushMessage } from '../lib/util';
import { PushServiceFcm } from '../lib/pushservicefcm';
import { RemoteService } from './RemoteService';
import { ServidorProvider } from '../providers/servidor/servidor';
import { EmpresaProvider } from '../providers/empresa/empresa';
import { AreaLocalProvider } from '../providers/area-local/area-local';
import { ContatoLocalProvider } from '../providers/contato-local/contato-local';
import { EmpresaLocalProvider } from '../providers/empresa-local/empresa-local';

import { AngularFireMessaging } from '@angular/fire/messaging';

var pushServiceInstance: PushService;

@Injectable()
export class PushService extends PushServiceFcm {

    constructor(public brComDao: BrComDao, 
        private brComService: BrComService, 
        private remoteService: RemoteService,
        events: Events, 
        device: Device,
        uniqueDeviceID: UniqueDeviceID,
        appVersion: AppVersion, 
        private contatoProvider: ContatoProvider,
        private areaProvider: AreaProvider,
        private empresaProvider: EmpresaProvider,
        angularFireMessaging: AngularFireMessaging,
        private contatoLocalProvider: ContatoLocalProvider,
        private empresaLocalProvider: EmpresaLocalProvider,
        private areaLocalProvider: AreaLocalProvider) {
        super(angularFireMessaging, events, device, uniqueDeviceID, appVersion);
        //super(push, events, device, uniqueDeviceID, appVersion);
        pushServiceInstance = this;
        brComService.pushService = this; // gambiarra, pois nao permite referencias ciclicas.
    }

    buildConfig(): PushConfig {
        let servidorPush = ServidorProvider.getIpPortaServidorPush();       
        return new PushConfig(servidorPush);
    }
     
    async deviceRegistered(deviceId: string, pushCode: number) {
        pushServiceInstance.remoteService.remoteCallSemLoading("registraToken", {
            imei: deviceId,
            tipo: 'I',
            versao: 1
        }, function (result: any) {
            pushServiceInstance.brComService.brComDao.gravaHexAparelho(result.hexAparelho);
        });
    }

     onPushMessage(msg: PushMessage) {
      /*  console.log("MSG PUSH PARA BRCOMUNIQUE :" + JSON.stringify(msg));
        if (msg.payload.tipo == "N") {
            if (msg.payload.conteudo.subtipo == "C") {
                console.log("MSG CADASTRO");
                pushServiceInstance.brComService.mensagemCadastroNovo(msg.payload.conteudo.codEmpresa, msg.payload.conteudo.codUsuario, msg.payload.conteudo.senha);
            }
        }*/
        if (msg.payload.tipo === "E") {
            this.empresaProvider.atualizarEmpresa();
        } else if (msg.payload.tipo === "U") {
            this.empresaProvider.atualizarUsuario();
        } else if (msg.payload.tipo === "LO") {
            this.brComService.limpar();
        } else if (msg.payload.idArea) {
            this.processarNovaMensagemArea(msg.payload);
        } else if (msg.payload.idContato) {
            this.processarNovaMensagemContato(msg.payload);
        }
    }

    private processarNovaMensagemArea(payload: any): void {
        const tipoMensagem = payload.tipo;
        if (tipoMensagem === "S") {
            this.areaProvider.processarMensagemSimples(payload)
        } else if (tipoMensagem === "L") {
            this.areaProvider.processarMensagemLink(payload);
        } else if (tipoMensagem === "F") {
            this.areaProvider.processarMensagemFacebook(payload);
        } else if (tipoMensagem === "H") {
            this.areaProvider.processarMensagemHTML(payload);
        } else if (tipoMensagem === "R") {
            this.areaProvider.processarMensagemResposta(payload);
        } else if (payload.tipo === "I") {
            this.areaProvider.processarMensagemImagem(payload);
        } else if (tipoMensagem === "SL") {
            this.areaLocalProvider.marcarMensagensLidas(payload.idArea, this.empresaLocalProvider.getIdUsuario());
        } else if (tipoMensagem === "A") {
            this.areaProvider.processarMensagemArquivo(payload);
        }
    }

    private processarNovaMensagemContato(payload: any): void {
        if (payload.tipo === "S") {
            this.contatoProvider.processarMensagemSimples(payload);
        } else if (payload.tipo === "I") {
            this.contatoProvider.processarMensagemImagem(payload);
        } else if (payload.tipo === "SL") {
            this.contatoLocalProvider.marcarMensagensDestinatarioLidas(payload.idContato);
        } else if (payload.tipo === "SC") {
            this.contatoProvider.sincronizarContato(payload.idContato);
        } else if (payload.tipo === "A") {
            this.contatoProvider.processarMesagemArquivo(payload);
        } else if (payload.tipo === "MR") {
            this.contatoProvider.processarMensagensRecebidas(payload.idContato);
        } else if (payload.tipo === "ML") {
            this.contatoProvider.processarMensagensLidas(payload.idContato);
        }
    }

    onProcessLastMessage(msg: any, local: string) {
        if (!msg) {
            console.log("msg is null");
            return;
        }
        if(pushServiceInstance.brComDao.obtemGrupos() == null){
            console.log("não está logado");
            return;
        }
        console.log('pushservice:onProcessLastMessage:' + JSON.stringify(msg)+":"+local);
        if (local!="INIT_APP" && local!="LOAD") {
            return;
        } else if (!msg.message || !msg.message.tipo) {
            return;
        } else if (msg.message.tipo=="C") {
            
        } else if (msg.message.tipo=="A") {

        } else if (msg.message.tipo=="S" || msg.message.tipo == "R") {
            //pushServiceInstance.brComService.iniciaPaginaConversaPorCodEmpresa(msg.message.codEmpresa);
        } else if (msg.message.tipo=="H" || msg.message.tipo=="F" || msg.message.tipo=="L"){
           /* if (msg.message.tipo=="H") {
                let link = msg.message.link
                if (!link){
                    link = pushServiceInstance.brComService.geraLinkHtml(msg.message)
                }
                pushServiceInstance.brComService.iniciaPaginaNavegador(link);
            } else {
                pushServiceInstance.brComService.abrePaginaComTipoURL(msg.message.link);
            }*/
        }
    }

    buildLocalNotification(msg: PushMessage): any {
        let p = {
            title: msg.title,
            text: msg.text,
            icon: "res://icon"
        };
        return p;
    }

    onNotificationClick(payload: any) {
      console.log("ON NOTIFICATION CLICK " + JSON.stringify(payload));
      if (payload.link) {
        pushServiceInstance.brComService.abrePaginaComTipoURL(payload.link);
        return;
      }
      //let codUsuario = pushServiceInstance.brComService.obtemCodUsuarioDaEmpresa(payload.codEmpresa);
      //pushServiceInstance.events.publish("iniciapagina:l:iniciaPaginaConversaPorCodEmpresa", { codEmpresa: payload.codEmpresa, codUsuario: codUsuario })
    }

}


// WEBPACK FOOTER //
// ./src/service/PushService.ts